<template>
    <div id="app">
        <home-header></home-header>
        <!--<home-nav></home-nav>-->
        <router-view/>
    </div>
</template>

<script>
    import homeHeader from '@/components/homeHeader';
    // import homeNav from '@/components/homeNav';
    import { mapMutations } from 'vuex';

    export default {
        name: 'App',
        components: {
            homeHeader,
            // homeNav
        },
        data() {
            return {
                teamList: [],
            }
        },
        methods: {
            ...mapMutations(['saveUserIp'])
        },
        mounted() {
            // 获取用户ip
            var cname = returnCitySN['cip'];
            this.saveUserIp(cname);
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue